var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-in_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.333,
    cy: 19.833,
    r: 18.083,
    stroke: "#D7D7D7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "m59.541 34.041 11.626 11.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M37.32 18.801h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M46.319 11.8v16h-2v-16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-in_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h100v48H.5z"
  })))));
};
export default SvgZoomIn;